import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const sandboxAccessControl: DomainAccessControlConfig = [
  { warehouseFeatureToggles: [FeatureToggle.sfpSandboxVisible], restrictedBannersAllowed: true },
  { featureToggles: [FeatureToggle.sfpSandboxUserVisible], restrictedBannersAllowed: true },
]

export const storefrontOnboardingLinkAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.StorefrontOnboarding],
}
